import Box from '@mui/material/Box';
import type { ComponentProps, CSSProperties } from 'react';
import type { ExtraProps } from 'react-markdown';

const visuallyHidden: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

type AnchorProps = ComponentProps<'a'> & ExtraProps;

/**
 * Renders a markdown link that opens in a new tab with an accessible
 * “opens in new window” hint for screen readers.
 */
export function MarkdownExternalLink({ href, children, node, ...rest }: AnchorProps) {
  void node;
  const hasText = children != null && String(children).replace(/\s/g, '').length > 0;
  return (
    <a {...rest} href={href} target="_blank" rel="noopener noreferrer">
      {hasText ? children : (href ?? 'Link')}
      <Box component="span" sx={visuallyHidden}>
        , opens in new window
      </Box>
    </a>
  );
}
